export default __webpack_public_path__ + "static/media/strapi.74cc583e.svg";